var map = {
	"./default.png": "2b47",
	"./jet.png": "8f88",
	"./paypal.png": "0773",
	"./pos.png": "277d",
	"./terminal.png": "5887",
	"./uber.png": "04e6",
	"./uber_eats.png": "a83f",
	"./web_app.png": "343c",
	"./wolt.png": "3f70"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "de3c";